"use strict";
/* eslint-disable jsx-a11y/alt-text */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const Input_1 = require("~/components/UI/Input");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const types_1 = require("~/store/types");
const consts_1 = require("~/components/Cad3d/consts");
const PreconfiguredFramesField_scss_1 = __importDefault(require("./PreconfiguredFramesField.scss"));
const SELECTOR_BY_FIELD_NAME = {
    [types_1.FieldName.seriesType]: selectors_1.selectSeriesTypeField,
    [types_1.FieldName.series]: selectors_1.selectSeriesField,
    [types_1.FieldName.profileType]: selectors_1.selectProfileTypeField,
    [types_1.FieldName.extrusion]: selectors_1.selectExtrusionField,
    [types_1.FieldName.handle]: selectors_1.selectHandleField,
    [types_1.FieldName.hinges]: selectors_1.selectHingesField,
    [types_1.FieldName.latch]: selectors_1.selectLatchField,
    [types_1.FieldName.panel]: selectors_1.selectPanelField,
    [types_1.FieldName.width]: selectors_1.selectWidthField,
    [types_1.FieldName.height]: selectors_1.selectHeightField,
    [types_1.FieldName.length]: selectors_1.selectLengthField,
};
function PreconfiguredFramesField({ name }) {
    var _a;
    const selector = SELECTOR_BY_FIELD_NAME[name];
    const field = (0, react_redux_1.useSelector)(selector);
    const isImperial = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    const [step] = (0, react_1.useState)(consts_1.consts.DEFAULT_EXTRUDE_STEP);
    const [min] = (0, react_1.useState)(0);
    const { dispatchSetSelectFieldValue, dispatchSetInputFieldValue } = (0, redux_1.bindActionCreators)({
        dispatchSetSelectFieldValue: actions_1.setSelectFieldValue,
        dispatchSetInputFieldValue: actions_1.setInputFieldValue,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        if (field.type === types_1.FieldType.SELECT &&
            field.options.length !== 0 &&
            !field.options.some((option) => option.value === field.value)) {
            dispatchSetSelectFieldValue({ fieldName: field.name, value: field.options[0].value });
        }
        if (field.type === types_1.FieldType.INPUT && !field.value) {
            dispatchSetInputFieldValue({ fieldName: field.name, value: 23 });
        }
    }, [dispatchSetSelectFieldValue, dispatchSetInputFieldValue, field]);
    console.log('Field', field);
    if (field.type === types_1.FieldType.INPUT && field.value !== undefined) {
        return (react_1.default.createElement("div", { className: PreconfiguredFramesField_scss_1.default.field, key: field.name },
            react_1.default.createElement("div", { className: PreconfiguredFramesField_scss_1.default.label }, isImperial ? field.imperialLabel : field.label),
            react_1.default.createElement(Input_1.Input, { type: field.inputType, onInput: (value) => {
                    dispatchSetInputFieldValue({ fieldName: field.name, value: Number(value) });
                }, onChange: (value) => {
                    dispatchSetInputFieldValue({ fieldName: field.name, value: Number(value) });
                }, value: field.value, step: step, min: min, placeholder: field.placeholder, precision: 3, arrows: true })));
    }
    if (field.type === types_1.FieldType.SELECT) {
        return (field === null || field === void 0 ? void 0 : field.options.length) !== 0 ? (react_1.default.createElement("div", { className: PreconfiguredFramesField_scss_1.default.field, key: field.name },
            react_1.default.createElement("div", { className: PreconfiguredFramesField_scss_1.default.label }, field.label),
            react_1.default.createElement(UI_1.Select
            // 192 = safe number (magic)
            , { 
                // 192 = safe number (magic)
                style: { height: 90, width: 130 }, options: field.options, selected: {
                    value: field.value,
                    label: (_a = field.options.find((option) => field.value === option.value)) === null || _a === void 0 ? void 0 : _a.label,
                }, onChange: (value) => value && dispatchSetSelectFieldValue({ fieldName: field.name, value }) }))) : null;
    }
    return null;
}
exports.default = PreconfiguredFramesField;
